import RouteParent from 'js/router/route-parent'

import UploadSalesIndex from 'js/pages/upload-sales/index.js'

export default [
  {
    path: '/upload-sales',
    component: RouteParent,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'upload-sales-index',
        component: UploadSalesIndex,
        meta: {
          auth: true
        }
      }
    ]
  }
]
